/* eslint-disable no-new */
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

export const carousel = (instance, nexBtn, prevBtn) => {
    new Swiper(instance, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        centeredSlides: true,
        slidesOffsetBefore: 0,
        breakpoints: {
            // when window width is <= 599px
            640: {
                slidesPerView: 3.9,
                spaceBetween: 40,
                centeredSlides: true,
                slidesOffsetBefore: -5,
            },
            // when window width is <= 999px
            999: {
                slidesPerView: 4,
                spaceBetween: 40,
                centeredSlides: true,
                slidesOffsetBefore: -25,
            },
            1200: {
                slidesPerView: 4.1,
                spaceBetween: 40,
                centeredSlides: true,
                slidesOffsetBefore: -35,
            },
            1400: {
                slidesPerView: 4.15,
                spaceBetween: 40,
                centeredSlides: true,
                slidesOffsetBefore: -30,
            },
            1600: {
                slidesPerView: 4.2,
                spaceBetween: 40,
                centeredSlides: true,
                slidesOffsetBefore: -5,
            },
            1800: {
                slidesPerView: 4.3,
                spaceBetween: 40,
                centeredSlides: true,
                slidesOffsetBefore: 20,
            },
        },
        navigation: {
            nextEl: nexBtn,
            prevEl: prevBtn,
        },
    });
};

export const carouselOverlay = (instance, nexBtn, prevBtn) => {
    new Swiper(instance, {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        navigation: {
            nextEl: nexBtn,
            prevEl: prevBtn,
        },
    });
};
